import axiosClient from 'utils/axiosClient';
import api from 'api';

const getQrVerifications = async (params?: any) => {
	const response = await axiosClient.get(api.RATING.QR_VERIFY.QR_SCAN_HISTORY, {params});
	return response.data;
};

const verifyQr = async (data: any) => {
	const response = await axiosClient.post(api.RATING.QR_VERIFY.QR_VERIFY, data);
	return response.data;
};

const service = {getQrVerifications, verifyQr};
export default service;
